






















import { Component, Prop, Vue } from "vue-property-decorator";

import { DetailSection } from "./competitorDetailRows";

// Generic presentational details renderer: takes ready-built sections (title +
// key/value rows) and renders them. Feature-specific components build the sections.
@Component
export default class DetailsTable extends Vue {
  @Prop({ required: true }) readonly sections!: DetailSection[];
}
